import { type PatientContextResponse } from '@/types';
import { atom } from 'jotai';

export const isGeneratingPatientContextAtom = atom<boolean>(false);

export const editablePatientContextAtom = atom<PatientContextResponse | null>(null);

export const patientDetailsPopupOpenAtom = atom<boolean>(false);
